'use strict';

const _ = require('underscore');
const ElementModel = require('system/domain/entity/element');
const RecordTypeStore = require('system/domain/repository/record-type');

const NodeModel = ElementModel.extend({
    /**
     * Node Model のベースクラス。
     *
     * 直接 new されることは無く、NodeModel.define により
     * 子クラスが定義され NodeModel.create により instantiate される。
     * @constructs
     */
    kind: 'node',
    defaults: {
        creating: false,
        deleted: false,
        deleting: false,
        name: '',
        description: '',
        tags: [],
        owners: [],
        values: null
    },

    initialize: function() {
        NodeModel.__super__.initialize.apply(this, arguments);
        _.bindAll(this, 'addTag', 'removeTag', 'addOwner', 'removeOwner');
    },

    getName: function() {
        return this.get('name');
    },

    addTag: function(id, options) {
        this.set({tags: _.union(this.get('tags'), [id])}, options);
    },

    removeTag: function(id) {
        this.set('tags', _.without(this.get('tags'), id));
    },

    addOwner: function(id, options) {
        this.set({owners: _.union(
            this.get('owners'),
            [id])}, options);
    },

    removeOwner: function(id) {
        this.set('owners', _.without(
            this.get('owners'), id));
    },

    getType: function() {
        return this.get('type');
    },

    i18nType: function() {
        const type = this.get('type');
        return RecordTypeStore.getRecordTypes().get(type).get('name');
    },

    // 既にサーバー側に保存済みの場合 true を返す
    isSaved: function() {
        return !this.get('creating');
    }
}, {
    _classes: {},

    defaults: {
        creating: false,
        deleting: false,
        name: '',
        description: '',
        tags: [],
        owners: [],
        values: null
    }
});

module.exports = NodeModel;



// WEBPACK FOOTER //
// ./system/domain/entity/node.js